/**
 * Hier kommt Code für die Mitarbeiter Übersicht hin
 */

import _  from 'underscore';
import dayjs from '../../../../shared/services/dayjs.js';
import stammdatenService from '../services/stammdatenService.js';
import { avatarFarbeAusName, debounce, displayValues, erstelleMitarbeiterListe, fuelleBeschaeftigungsartSelect, initialenAusName } from '../util.js';
import SystemDialogService from '../../../../shared/services/systemDialogService.js';
import systemNachrichtService from '../services/systemNachrichtService.js';
import basedataService from '../services/basedataService.js';
import { debounceSpeichereMA } from './ma_daten.js';
import { Roles } from '../../../../../domain/konstanten/Roles.js';

// Lesbare Bezeichnungen der Entlohnungsarten (analog zum Select in ma_beschaeftigung.html)
const ENTLOHNUNGSART_LABELS = {
    gewerblichAzubi: 'Azubi gewerblich',
    kaufmannAzubi: 'Azubi kaufmännisch',
    Effektivlohn: 'Effektivlohn',
    Zielbrutto: 'Zielbrutto',
    Monatslohn: 'Monatslohn',
    Stundenlohn: 'Stundenlohn',
    Umsatzanteilslohn: 'Umsatzanteilslohn (mtl)',
    umsatzorientierterStundenlohn: 'umsatzorient. Stundenlohn (mtl)',
    UmsatzanteilslohnTaeglich: 'Umsatzanteilslohn (tgl)',
    umsatzorientierterStundenlohnTaeglich: 'umsatzorient. Stundenlohn (tgl)',
};

const debounceUpdateAufgabeMA = debounce(async (args) => {
    await speichereMitarbeiterAufgabe(args[0]);
});

window.myHandlers = window.myHandlers || {};
window.myHandlers.debounceUpdateAufgabeMA = debounceUpdateAufgabeMA;
window.myHandlers.neueMitarbeiterAufgabe = neueMitarbeiterAufgabe;
window.myHandlers.clickZurBenutzerverwaltung = clickZurBenutzerverwaltung;
window.myHandlers.generiereAktivierungsCode = generiereAktivierungsCode;
window.myHandlers.beantrageSofortmeldung = beantrageSofortmeldung;
window.myHandlers.storniereSofortmeldung = storniereSofortmeldung;
window.myHandlers.reaktiviereMitarbeiterLoginClick = reaktiviereMitarbeiterLoginClick;
window.myHandlers.deaktiviereMitarbeiterLoginClick = deaktiviereMitarbeiterLoginClick;
window.myHandlers.reaktiviereMitarbeiterClick = reaktiviereMitarbeiterClick;
window.myHandlers.archiviereMitarbeiterClick = archiviereMitarbeiterClick;
window.myHandlers.wechsleBeschaeftigungMA = wechsleBeschaeftigungMA;
window.myHandlers.confirmWechselBeschaeftigungMA = confirmWechselBeschaeftigungMA;
window.myHandlers.updateWechselBeschaeftigungHinweis = updateWechselBeschaeftigungHinweis;
window.myHandlers.widerrufeWechselBeschaeftigungMA = widerrufeWechselBeschaeftigungMA;
window.myHandlers.speichereMitarbeiterNotiz = speichereMitarbeiterNotiz;

/**
 * Bestückt die Mitarbeiter Übersicht mit Daten des aktuellen Mitarbeiters
 * @param {object} aktuellerMA
 * @param {object} unternehmen
 */
async function ladeUebersicht(aktuellerMA, unternehmen) {
    if (!_.isEmpty(aktuellerMA)) {
        // Mitarbeiter Notizen und Nachrichten laden...
        document.getElementById('ma-notizen').value = stammdatenService.aktuellerMitarbeiter.Uebersicht.Notizen;
        ladeMitarbeiterAufgaben(aktuellerMA.Uebersicht.Nachrichten); // Aufgaben laden
        const aktuelleBeschaeftigung = aktuellerMA.Beschaeftigung[0];
        const htmlParent = document.getElementById('ma-Uebersicht');
        htmlParent.querySelector('#ma-KurzfristigeTage').style.display = aktuelleBeschaeftigung.Personengruppenschluessel === '110' ? 'grid' : 'none';
        document.querySelector('#ma-login-info').style.display = 'none';
        displayValues(aktuellerMA.Uebersicht, '', htmlParent, 'ma-');
        displayValues(aktuelleBeschaeftigung, '', htmlParent, 'ma-');
        displayValues(aktuellerMA.Personalien, '', htmlParent, 'ma-');
        // Entlohnungsart in lesbare Bezeichnung übersetzen (Rohwert von displayValues)
        const entlohnungHTML = htmlParent.querySelector('[aria-label="ma-Entlohnung"]');
        entlohnungHTML.innerText = ENTLOHNUNGSART_LABELS[entlohnungHTML.innerText] ?? entlohnungHTML.innerText;
        // Verwendete Qualifikationen sammeln (ohne Duplikate, Anzeige in der Avatar-Kopfzeile)
        const qualifikationen = [...new Set(
            aktuelleBeschaeftigung.Verguetung
                .filter((quali) => quali.Verwenden)
                .map((quali) => unternehmen.Qualifikationen.find((q) => q._id === quali.QualifikationID)?.BezeichnungNeutral)
                .filter(Boolean)
        )].join(', ');
        // Zugeordnete Posten anzeigen
        const postenHTML = htmlParent.querySelector('[aria-label="ma-Posten"]');
        postenHTML.innerText = '';
        let postenMatchCounter = 0;
        // Wähle aktuelle Betriebsstätte des Mitarbeiters
        const aktuelleBS = unternehmen.Betriebsstaette.find((bs) => bs._id === aktuelleBeschaeftigung.BetriebsstaetteID);
        if (aktuelleBS) {
            htmlParent.querySelector('[aria-label="ma-BetriebsstaetteName"]').innerText = aktuelleBS.BetriebsstaetteName;
            aktuelleBeschaeftigung.Posten.forEach((posten) => {
                const postenCounter = aktuelleBS.Posten.find((b) => b._id === posten.PostenID);
                if (postenCounter !== undefined) {
                    postenHTML.innerText += `${postenMatchCounter === 0 ? '' : ', '}${postenCounter.Posten}`;
                    postenMatchCounter += 1;
                }
            });
            if (postenMatchCounter === 0) {
                postenHTML.innerText = 'keine Posten';
            }
        } else {
            htmlParent.querySelector('[aria-label="ma-BetriebsstaetteName"]').innerText = 'keiner Betriebsstätte zugeordnet';
            postenHTML.innerText = 'keine Posten';
        }
        // Regelarbeitstage anzeigen (abhängig von den eingegebenen Regelarbeitszeiten in der Beschäftigung)
        const tage = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];
        const regeltage = htmlParent.querySelector('[aria-label="ma-Regelarbeitstage"]');
        regeltage.innerText = '';
        aktuelleBeschaeftigung.Regelarbeitstage.forEach((tag, index) => {
            if (tag) {
                regeltage.innerText += `${index === 0 || regeltage.innerText === '' ? '' : ', '}${tage[index]}`;
            }
        });
        
        // Beschäftigungsart anzeigen (in der Beschäftigungszeile beim Wechsel-Button)
        const beschArten = await basedataService.holeBeschaeftigungsartenBasedataProvider();
        const beschaeftigungsartKurz = beschArten.find((ba) => ba.BeschID === aktuelleBeschaeftigung.Beschaeftigungsart)?.BeschaeftigungsartKurz;
        const beschString = beschaeftigungsartKurz ? `${beschaeftigungsartKurz}, ${aktuelleBeschaeftigung.Personengruppenschluessel}` : '';
        htmlParent.querySelector('[aria-label="ma-Beschaeftigungsart"]').innerText = beschString ?? '';
        // Profilbild/Initialen-Avatar in der Kopfzeile setzen
        ladeMitarbeiterAvatar(aktuellerMA, htmlParent, qualifikationen, beschaeftigungsartKurz ?? '');
        // User Login Status anzeigen
        updateArchivStatusButtons(aktuellerMA?.Archiviert);
        // Sofortmeldung anzeigen
        ladeSofortmeldung(aktuellerMA);
        // Mitarbeiter Zeiterfassung Aktivierungscode
        await ladeAktivierungsCode(aktuellerMA._id);
        // Beschaeftigungswechselinfo anzeigen
        await updateWechselBeschaeftigungInfo(aktuellerMA._id);
        // Mitarbeiter Benutzerinfo anzeigen
        await updateLoginStatusInfo(aktuellerMA);
    } else {
        await SystemDialogService.instance.displayAsync('kein-ma-alert-dialog');
    }
}

/**
 * Setzt das Profilbild des Mitarbeiters (bzw. den Initialen-Fallback) in der Quick-Info Kopfzeile.
 * Die Initialen werden sofort gesetzt, das Profilbild (aus der ma_avatare Collection)
 * wird asynchron nachgeladen und ersetzt die Initialen, sofern vorhanden.
 * @param {object} aktuellerMA
 * @param {HTMLElement} htmlParent Container der Mitarbeiter Übersicht
 * @param {string} qualifikationen Komma-separierte Qualifikationen des Mitarbeiters
 * @param {string} beschaeftigungsart Kurzbezeichnung der Beschäftigungsart
 */
function ladeMitarbeiterAvatar(aktuellerMA, htmlParent, qualifikationen, beschaeftigungsart) {
    const avatar = htmlParent.querySelector('.ma-avatar');
    if (!avatar) return;
    const vorname = aktuellerMA.Personalien?.Vorname ?? '';
    const nachname = aktuellerMA.Personalien?.Nachname ?? '';
    const name = `${vorname} ${nachname}`.trim();
    // Name + Meta-Zeilen (Personalnr. · Qualifikation, darunter die Beschäftigung)
    htmlParent.querySelector('.ma-avatar-name').innerText = name || '–';
    const personalnummer = aktuellerMA.Personalien?.Personalnummer;
    const metaTeile = [personalnummer ? `PNR ${personalnummer}` : '', qualifikationen].filter(Boolean);
    htmlParent.querySelector('.ma-avatar-rolle').innerText = metaTeile.join(' · ');
    htmlParent.querySelector('.ma-avatar-beschaeftigung').innerText = [`PGS ${aktuellerMA.Beschaeftigung[0].Personengruppenschluessel}`, beschaeftigungsart].filter(Boolean).join(' · ');
    // Initialen + deterministische Farbe aus dem Namen ableiten (sofortiger Fallback)
    const farbe = avatarFarbeAusName(name);
    avatar.style.setProperty('--ma-avatar-bg', farbe.bg);
    avatar.style.setProperty('--ma-avatar-fg', farbe.fg);
    avatar.querySelector('.ma-avatar-initialen').innerText = initialenAusName(vorname, nachname);
    const img = avatar.querySelector('.ma-avatar-img');
    img.removeAttribute('src');
    avatar.classList.remove('has-foto');
    // Profilbild asynchron aus der ma_avatare Collection nachladen
    ladeProfilbild(aktuellerMA._id, avatar, img, name);
}

/**
 * Lädt das Profilbild des Mitarbeiters und blendet es ein, sofern hinterlegt.
 * @param {string} mitarbeiterID
 * @param {HTMLElement} avatar Avatar-Kreis Element
 * @param {HTMLImageElement} img Bild-Element im Avatar
 * @param {string} name Mitarbeitername (alt-Text)
 */
async function ladeProfilbild(mitarbeiterID, avatar, img, name) {
    const avatarObjekt = await stammdatenService.ladeMitarbeiterProfilbild(mitarbeiterID);
    const profilbild = avatarObjekt?.Profilbild;
    if (!profilbild?.base64 || !profilbild?.MimeType) return;
    // Mitarbeiter könnte währenddessen gewechselt haben -> nur anwenden, wenn noch aktuell
    if (stammdatenService.aktuellerMitarbeiter?._id !== mitarbeiterID) return;
    img.src = `data:${profilbild.MimeType};base64,${profilbild.base64}`;
    img.alt = name;
    avatar.classList.add('has-foto');
}

/**
 * Click auf den Benutzerverwaltungsbutton leitet den User zur Benutzerverwaltung
 */
function clickZurBenutzerverwaltung() {
    window.myHandlers.topmenuClick(document.getElementById('Verwaltung'));
    window.myHandlers.submenuClick(document.getElementById('Benutzer'));
}

/**
 * Lädt/Aktualisiert die Statusanzeige der Sofortmeldung des aktuellen Mitarbeiters
 * @param {object} aktuellerMA
 */
function ladeSofortmeldung(aktuellerMA) {
    const sectionHTML = document.getElementById('ma-sofortmeldung-section');
    const sofortmeldungMA = aktuellerMA.Beschaeftigung[0].Sofortmeldung;
    const keineSofortmeldung = _.isEmpty(sofortmeldungMA?.Results);
    // Anzeigen des Sofortmelde Buttons nur falls es noch keine Sofortmeldung gab oder ein Storno vorliegt.
    sectionHTML.querySelector('.verwenden-button').style.display = _.isEmpty(sofortmeldungMA?.TAN) || sofortmeldungMA?.Status === 'storniert' ? 'block' : 'none';
    // Anzeige des Stornieren Buttons nur falls eine Stornierbare Sofortmeldung vorliegt.
    sectionHTML.querySelector('.entfernen-button').style.display = sofortmeldungMA?.Stornierbar ? 'block' : 'none';
    // reset info
    [...sectionHTML.querySelectorAll('.sofortmeldung-details')].forEach((item) => item.remove());
    if (!keineSofortmeldung) {
        const sofortmeldungTemplate = sectionHTML.querySelector('[ma-sofortmeldung-template]');
        const sofortmeldungDetails = sofortmeldungTemplate.content.cloneNode(true);
        displayValues(sofortmeldungMA, '', sofortmeldungDetails, 'ma-Sofortmeldung-');
        sectionHTML.appendChild(sofortmeldungDetails);
        if (sofortmeldungMA?.Status === 'storniert') {
            // Stornierungsfelder sichtbar machen
            [...sectionHTML.querySelectorAll('.ma-sm-storniert')].forEach((item) => { item.style.display = 'grid'; });
        } else {
            [...sectionHTML.querySelectorAll('.ma-sm-storniert')].forEach((item) => { item.style.display = 'none'; });
        }
    }
}

/**
 * Lädt den Benutzer Login Status
 * @param {*} aktuellerMA 
 */
async function updateLoginStatusInfo(aktuellerMA) {
     // Mitarbeiter Benutzerinfo anzeigen
     const userRollenHtml = document.querySelector('#ma-user-rollen');
     userRollenHtml.style.display = 'none';    
     const benutzer = await stammdatenService.ladeInternerMitarbeiterUser(aktuellerMA._id);
     if (!_.isEmpty(benutzer)) {
         const benutzerRollen = benutzer.neolohnRoles.filter((rolle) => rolle !== Roles.Mitarbeiter);
         if (benutzerRollen.length >= 1) {
             document.querySelector('[aria-label="ma-UserRollen"').innerText = benutzerRollen.join(',\n');
             userRollenHtml.style.display = 'grid';
         }
         if (benutzer.enabled) {
             updateLoginStatusButtons(true, true);
         } else {
             updateLoginStatusButtons(true, false);    
         }
     } else {
         updateLoginStatusButtons(false, false);
     }
    document.querySelector('#ma-login-info').style.display = 'flex';
}

function updateLoginStatusButtons(exists, loginStatus) {
    // ingorieren falls Seite verlassen
    if (window.myVars.websiteStatus !== 'ma-uebersicht') return;
    document.querySelector('[aria-label="ma-LoginStatus"]').innerText = loginStatus ? 'aktiv' : 'inaktiv';
    document.querySelector('[aria-label="ma-login-reaktivieren"]').style.display = loginStatus ? 'none' : 'block';
    document.querySelector('[aria-label="ma-login-reaktivieren"]').innerText = exists ? 'reaktivieren' : 'aktivieren';
    document.querySelector('[aria-label="ma-login-deaktivieren"]').style.display = loginStatus ? 'block' : 'none';
}

function updateArchivStatusButtons(archivStatus) {
    document.querySelector('[aria-label="ma-archiv-reaktivieren"]').style.display = archivStatus ? 'block' : 'none';
    document.querySelector('[aria-label="ma-archiv-archivieren"]').style.display = !archivStatus ? 'block' : 'none';
}

async function neueMitarbeiterAufgabe(thisElement) {
    const parentElement = thisElement.closest('.fieldset3columns');
    const aufgabe = parentElement.querySelector('#ma-aufgabe-text');
    if (aufgabe.value === '') {
        systemNachrichtService.zeigeKleineNachricht('kein Aufgabentext angebeben!');
        return;
    }
    // server request...
    const mitarbeiterID = stammdatenService.aktuellerMitarbeiter._id;
    const aufgabenObjekt = await stammdatenService.postMitarbeiterAufgabe(mitarbeiterID, aufgabe.value);
    if (!aufgabenObjekt) {
        return;
    }
    const maControl = document.getElementById(mitarbeiterID);
    // Zeige das Aufgaben Symbol beim Mitarbeiter an
    maControl.querySelector('.ma-aufgabe-icon').classList.remove('hidden');
    const template = document.querySelector('[ma-aufgabe-template]');
    const liste = document.getElementById('ma-aufgaben-liste');
    const neueAufgabe = template.content.cloneNode(true).children[0];
    neueAufgabe.id = aufgabenObjekt._id;
    neueAufgabe.querySelector('[aria-label="ma-Aufgaben-Nachricht"]').value = aufgabenObjekt.Nachricht;
    neueAufgabe.querySelector('[aria-label="ma-Aufgaben-ErstelltVon"]').innerText = aufgabenObjekt.ErstelltVon;
    neueAufgabe.querySelector('[aria-label="ma-Aufgaben-ErstelltDatum"]').innerText = dayjs(aufgabenObjekt.ErstelltDatum).tz().format('DD.MM.YY');
    liste.prepend(neueAufgabe);
    aufgabe.value = '';
}

/**
 * Speichert die aktualisierte Mitarbeiter Aufgabe
 * - im Code werden Aufgaben unter Nachrichten gespeichert
 * @param {HTMLElement} thisElement
 */
async function speichereMitarbeiterAufgabe(thisElement) {
    const parentElement = thisElement.closest('.ma-aufgabe-item');
    const aufgabeId = parentElement.id;
    // Nachricht ist Aufgabe im MA Objekt
    const aufgabeNeu = parentElement.querySelector('[aria-label="ma-Aufgaben-Nachricht"]').value;
    const erledigt = parentElement.querySelector('[aria-label="ma-Aufgaben-Erledigt"]').checked;
    const mitarbeiterID = stammdatenService.aktuellerMitarbeiter._id;
    const aufgabenObjekt = await stammdatenService.updateMitarbeiterAufgabe(mitarbeiterID, aufgabeId, aufgabeNeu, erledigt);
    parentElement.querySelector('[aria-label="ma-Aufgaben-BearbeitetVon"]').innerText = aufgabenObjekt.BearbeitetVon;
    parentElement.querySelector('[aria-label="ma-Aufgaben-BearbeitetDatum"]').innerText = dayjs(aufgabenObjekt.BearbeitetDatum).tz().format('DD.MM.YY');
    parentElement.querySelector('.ma-notizen-bearbeitet-info').style.display = 'block';
    aufgabenObjekt.Erledigt ? parentElement.classList.add('erledigt') : parentElement.classList.remove('erledigt');

    // Zeige das Aufgaben Symbol beim Mitarbeiter an falls auf unerledigt gesetzt und ausblenden wenn erledigt
    const maControl = document.getElementById(mitarbeiterID);
    const aufgabenSymbolMA = maControl.querySelector('.ma-aufgabe-icon');
    // Neue Nachricht = Neue Aufgabe
    if (!stammdatenService.aktuellerMitarbeiter.Uebersicht.NeueNachricht) {
        aufgabenSymbolMA.classList.add('hidden');
        return;
    }
    aufgabenSymbolMA.classList.remove('hidden');
}

/**
 * Lädt die Aufgaben des Mitarbeiters in die Oberfläche
 * @param {array} aufgaben
 */
function ladeMitarbeiterAufgaben(aufgaben) {
    const template = document.querySelector('[ma-aufgabe-template]');
    const liste = document.getElementById('ma-aufgaben-liste');
    liste.innerHTML = '';
    aufgaben.sort((a, b) => new Date(b.BearbeitetDatum || b.ErstelltDatum) - new Date(a.BearbeitetDatum || a.ErstelltDatum));
    aufgaben.sort((a, b) => a.Erledigt - b.Erledigt);
    aufgaben.forEach((aufgabe) => {
        const neueNachricht = template.content.cloneNode(true).children[0];
        neueNachricht.id = aufgabe._id;
        displayValues(aufgabe, '', neueNachricht, 'ma-Aufgaben-');
        if (aufgabe.BearbeitetVon) {
            neueNachricht.querySelector('.ma-notizen-bearbeitet-info').style.display = 'block';
        }
        aufgabe.Erledigt ? neueNachricht.classList.add('erledigt') : neueNachricht.classList.remove('erledigt');
        liste.appendChild(neueNachricht);
    });
}

// fetcht den Aktivierungscode des mitarbeiters falls vorhanden
async function ladeAktivierungsCode(mitarbeiterID) {
    try {
        const response = await fetch(`/neolohn/api/mitarbeiter/${mitarbeiterID}/aktivierungscode`);
        const span = document.getElementById('ma-activation-code-number');
        const btn = document.getElementById('ma-activation-code-button');
        // Reset der Info
        span.innerText = '';
        span.style.display = 'none';
        btn.style.display = 'none';
        if (!response.ok) {
            const message = await response.text();
            systemNachrichtService.zeigeKleineNachricht(message, 0);
            throw new Error(`HTTP error, status = ${response.status}`);
        }
        const result = await response.text();
        if (result !== '') {
            span.innerText = result;
            span.style.display = 'block';
        } else {
            btn.style = 'block';
        }
    } catch (error) {
        console.log(error);
    }
}

// fetch anfrage für die Erstellung eines Aktivierungscode für die Zeiterfassung
async function generiereAktivierungsCode() {
    try {
        const mitarbeiterID = stammdatenService.aktuellerMitarbeiter._id;
        const response = await fetch(`/neolohn/api/mitarbeiter/${mitarbeiterID}/aktivierungscode`, {
            method: 'POST',
        });
        if (response.ok) {
            // Reset der Info
            const span = document.getElementById('ma-activation-code-number');
            const btn = document.getElementById('ma-activation-code-button');
            span.innerText = '';
            span.style.display = 'none';
            btn.style.display = 'none';
            span.innerText = await response.text();
            span.style.display = 'block';
            systemNachrichtService.zeigeKleineNachricht('Erstellen des Aktivierungscodes erfolgreich!', 1);
        }
    } catch (error) {
        systemNachrichtService.zeigeKleineNachricht('Erstellen des Aktivierungscodes fehlgeschlagen!', -1);
    }
}

/**
 * Click Handler für die Erstellung einer Mitarbeiter Sofortmeldung
 */
async function beantrageSofortmeldung() {
    const aktuellerMA = stammdatenService.aktuellerMitarbeiter;
    const betriebssaetteMA = aktuellerMA.Beschaeftigung[0].BetriebsstaetteID;
    const aktuelleBetriebsstaette = stammdatenService.unternehmensobjekt.Betriebsstaette.find((bs) => _.isEqual(bs._id, betriebssaetteMA));
    if (!aktuelleBetriebsstaette) {
        return systemNachrichtService.zeigeKleineNachricht('Betriebsstätte nicht gefunden!', -1);
    }
    const dialogHtml = document.getElementById('ma-sofortmeldung-beantragen-dialog');
    const dialogBody = dialogHtml.querySelector('.app-dialog-body');
    dialogBody.innerHTML = '';
    const templateBody = dialogHtml.querySelector('[ma-sm-body-template]');
    const clone = templateBody.content.cloneNode(true);
    displayValues(aktuellerMA, '', clone, 'ma-sm-dialog-');
    displayValues(aktuellerMA.Personalien.Staatsangehoerigkeit, '', clone, 'ma-sm-dialog-Staatsangehoerigkeit-');
    displayValues(aktuellerMA.Personalien.Geburtsland, '', clone, 'ma-sm-dialog-Geburtsland-');
    displayValues(aktuelleBetriebsstaette, '', clone, 'bs-sm-dialog-');
    dialogBody.appendChild(clone);
    const input = await SystemDialogService.instance.displayAsync('ma-sofortmeldung-beantragen-dialog');
    if (input.success) {
        const result = await stammdatenService.postSofortmeldungMitarbeiter(aktuellerMA._id, aktuelleBetriebsstaette._id);
        if (result?.status === 'success') {
            ladeSofortmeldung(stammdatenService.aktuellerMitarbeiter);
        } else {
            // Fehler anzeigen
            const body = document.getElementById('ma-sm-error-body');
            const boldText = document.createElement('b');
            boldText.innerText = `Mitarbeiter: ${aktuellerMA.Personalien.Nachname}, ${aktuellerMA.Personalien.Vorname}`;
            body.appendChild(boldText);
            result.forEach((error) => {
                if (error.keyword === 'if') {
                    return;
                }
                const newRow = document.createElement('p');
                newRow.innerText = `${error.message}`;
                body.appendChild(newRow);
            });
            await SystemDialogService.instance.displayAsync('ma-sofortmeldung-error-dialog');
            body.innerText = '';
            ladeSofortmeldung(stammdatenService.aktuellerMitarbeiter);
        }
    }
    dialogBody.innerHTML = '';
}

/**
 * Click Handler für die Stornierung einer Mitarbeiter Sofortmeldung
 */
async function storniereSofortmeldung() {
    const aktuellerMA = stammdatenService.aktuellerMitarbeiter;
    const dialogHtml = document.getElementById('ma-sofortmeldung-stornieren-dialog');
    const dialogName = dialogHtml.querySelector('#ma-sm-storno-name');
    dialogName.innerText = `${aktuellerMA.Personalien.Vorname} ${aktuellerMA.Personalien.Nachname}`;
    const input = await SystemDialogService.instance.displayAsync('ma-sofortmeldung-stornieren-dialog');
    if (input.success) {
        // führe storno aus
        await stammdatenService.postStornierungSofortmeldungMitarbeiter(aktuellerMA._id);
        ladeSofortmeldung(stammdatenService.aktuellerMitarbeiter);
    }
    dialogName.innerText = '';
}

// onclick handler für das Reaktivieren eines Mitarbeiter Logins
async function reaktiviereMitarbeiterLoginClick() {
    const input = await SystemDialogService.instance.displayAsync('ma-aktivieren-dialog');
    if (!input.success) {
        return;
    }
    const result = await stammdatenService.reaktivereMitarbeiterLogin(stammdatenService.aktuellerMitarbeiter._id);
    if (!result) {
        return;
    }
    await updateLoginStatusInfo(stammdatenService.aktuellerMitarbeiter);
}

// onclick handler für das Deaktivieren eines Mitarbeiter Logins
async function deaktiviereMitarbeiterLoginClick() {
    const input = await SystemDialogService.instance.displayAsync('ma-deaktivieren-dialog');
    if (!input.success) {
        return;
    }
    const result = await stammdatenService.deaktivereMitarbeiterLogin(stammdatenService.aktuellerMitarbeiter._id);
    if (!result) {
        return;
    }
    await updateLoginStatusInfo(stammdatenService.aktuellerMitarbeiter);
}

// onclick handler für das Archivieren eines Mitarbeiters
async function archiviereMitarbeiterClick() {
    const input = await SystemDialogService.instance.displayAsync('ma-archivieren-dialog');
    if (!input.success) {
        return;
    }
    const result = await stammdatenService.archiviereMitarbeiter(stammdatenService.aktuellerMitarbeiter._id);
    if (!result) {
        return;
    }
    await ladeUebersicht(stammdatenService.aktuellerMitarbeiter, stammdatenService.unternehmensobjekt);
    erstelleMitarbeiterListe(stammdatenService.aktuelleBetriebsstaette);
}

// onclick handler für das Reaktivieren eines Mitarbeiters
async function reaktiviereMitarbeiterClick() {
    const result = await stammdatenService.reaktivereMitarbeiter(stammdatenService.aktuellerMitarbeiter._id);
    if (!result) {
        return;
    }
    await ladeUebersicht(stammdatenService.aktuellerMitarbeiter, stammdatenService.unternehmensobjekt);
    erstelleMitarbeiterListe(stammdatenService.aktuelleBetriebsstaette);
}

/**
 * Event Handler für Klick auf Mitarbeiter Kopieren Button in der ma_uebersicht.html
 */
async function wechsleBeschaeftigungMA() {
    const aktuellerMA = stammdatenService.aktuellerMitarbeiter;
    // Dialog bestücken...
    const dialogHtml = document.getElementById('ma-beschaeftigung-wechsel-dialog');
    dialogHtml.querySelector('#mb-wechsel-austritt').value = aktuellerMA.Beschaeftigung[0].Austrittsdatum;
    dialogHtml.querySelector('#mb-wechsel-personalnummer').value = aktuellerMA.Personalien.Personalnummer;
    const selectBeschaeftigung = dialogHtml.querySelector('#mb-wechsel-beschaeftigungsart');
    const beschaeftigungen = await basedataService.holeBeschaeftigungsartenBasedataProvider();
    const eigeneVorlagen = stammdatenService.unternehmensobjekt.BeschaeftigungsartVorlagen ?? [];
    fuelleBeschaeftigungsartSelect(selectBeschaeftigung, eigeneVorlagen, beschaeftigungen);
    selectBeschaeftigung.value = aktuellerMA.Beschaeftigung[0].BeschaeftigungsartVorlageID || aktuellerMA.Beschaeftigung[0].Beschaeftigungsart;
    const input = await SystemDialogService.instance.displayAsync('ma-beschaeftigung-wechsel-dialog');
    if (!input.success) {
        return;
    }
    await stammdatenService.kopiereMitarbeiterBeschaeftigungswechsel(aktuellerMA._id, input.data);
    // liste und mitarbeiter neu laden...
    await stammdatenService.holeMitarbeiter(aktuellerMA._id);
    ladeUebersicht(stammdatenService.aktuellerMitarbeiter, stammdatenService.unternehmensobjekt);
	await erstelleMitarbeiterListe(stammdatenService.aktuelleBetriebsstaette);
}

// Dialog confirm handler
function confirmWechselBeschaeftigungMA() {
    const dialogHtml = document.getElementById('ma-beschaeftigung-wechsel-dialog');
    const austrittAlt = dialogHtml.querySelector('#mb-wechsel-austritt').value;
    const eintrittNeu = dialogHtml.querySelector('#mb-wechsel-eintritt').value;
    // nicht ohne richte Datumsangaben abschicken lassen
    if (austrittAlt > eintrittNeu || austrittAlt === '' || eintrittNeu === '') {
        systemNachrichtService.zeigeKleineNachricht('Eintrittsdatum muss nach dem Austrittsdatum liegen!');
        return;
    }
    SystemDialogService.instance.confirm({
		AustrittsdatumAlt: austrittAlt,
		EintrittsdatumNeu: eintrittNeu,
		BeschaeftigungsartNeu: dialogHtml.querySelector('#mb-wechsel-beschaeftigungsart').value,
		PersonalnummerNeu: dialogHtml.querySelector('#mb-wechsel-personalnummer').value
	});
}

function updateWechselBeschaeftigungHinweis(thisElement) {
    // Regex  /^0\d+/ testet of die jahreszahl korrekt ist (bzw. nicht mit 0 anfängt).
    if (thisElement.value === '' || /^0\d+/.test(thisElement.value)) return;
    const isInFuture = !/^0\d+/.test(thisElement.value) && new Date() <= new Date(thisElement.value);
    document.getElementById('mb-wechsel-hinweis').style.display = !isInFuture ? 'block' : 'none';
    document.getElementById('mb-wechsel-hinweis2').style.display = isInFuture ? 'block' : 'none';
}

async function updateWechselBeschaeftigungInfo(mitarbeiterID) {
    // Nur Sachbearbeiter rufen diese Info ab.
    if (window.myVars.HideMod) return;
    const bw = await stammdatenService.holeBeschaeftigungsWechselAnfrage(mitarbeiterID);
    if (_.isEmpty(bw)) {
        document.getElementById('ma-bw-button').disabled = false;
        document.getElementById('ma-bw-button').style.display = 'block';
        document.getElementById('ma-bw-aktuell').style.display = 'none';
    } else {
        document.getElementById('ma-bw-status').innerText = bw.WechselAbgeschlossen ? 'Gewechselt zum: ' : 'Geplant am: ';
        document.getElementById('ma-bw-button').disabled = true;
        document.getElementById('ma-bw-button').style.display = 'none';
        const bwDiv = document.getElementById('ma-bw-aktuell');
        bwDiv.style.display = 'flex';
        displayValues(bw, '', bwDiv, 'ma-bw-');
        // Wechsel kann nur Zurückgenommen werden, wenn der Wechsel noch bevorsteht
        document.getElementById('ma-bw-withdraw').style.display = dayjs.tz(new Date(), dayjs.tz.DEFAULT_TZ).format('YYYY-MM-DD') < bw.WechselDatum ? 'block' : 'none';
    }
}

async function widerrufeWechselBeschaeftigungMA() {
    const result = await stammdatenService.widerrufeBeschaeftigungsWechselAnfragen(stammdatenService.aktuellerMitarbeiter._id);
    if (result) {
        document.getElementById('ma-bw-button').disabled = false;
        document.getElementById('ma-bw-button').style.display = 'block';
        const bwDiv = document.getElementById('ma-bw-aktuell');
        bwDiv.style.display = 'none';
    }
}

/**
 * Speichert das aktuelle Mitarbeiternotizenfeld
 * @param {*} thisElement Notiz textarea
 */
function speichereMitarbeiterNotiz(thisElement) {
    const aktuellerMA = stammdatenService.aktuellerMitarbeiter;
    aktuellerMA.Uebersicht.Notizen = thisElement.value;
    window.myVars.mitarbeiterEditiert = true;
    debounceSpeichereMA(aktuellerMA);
}

export { ladeUebersicht };